<template>
  <div class="section" id="proyectos">
    <b-container>
      <b-row align-v="center">
        <b-col>
          <h1>Proyectos</h1>
          <p>Texto aca:</p>
          <agile :options="options" ref="productos" v-if="items">
            <div class="slide" v-for="(item, index) in items" v-bind:key="index">
              <img :src="'/upload/' + item.image" />
              <p>{{ item.text }}</p>
            </div>
          </agile>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      items: null,
      options: {
        centerMode: true,
        slidesToShow: 1,
        autoplay: true,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      }
    }
  },
  created () {
    this.get_items()
  },
  methods: {
    get_items () {
      var self = this

      this.$http.get('/proyectos.json').then(function (response) {
        self.items = response.data
      })
    }
  }
}
</script>
